import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { 
  GET_CHANNEL_PARTNER_LISTING, 
  TRANSFER_HANDOVER_TO_CHANNEL_PARTNER,
  GET_CONTRACTS_BY_CHANNEL_PARTNER,
  INVOICE_VISIBILITY_FOR_CHANNEL_PARTNER 
} from "./type";

export const getChannelPartnerListing = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.channelPartner.getChannelPartnerListing
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_CHANNEL_PARTNER_LISTING,
      payload: data,
    });
  } else {
    return res;
  }
};

export const transferHandoverAgainstChannelPartner = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            Config.channelPartner.transferHandoverToChannelPartner
        );
        if (res?.data?.status == 0) {
            const { data } = res;
            dispatch({ 
                type: TRANSFER_HANDOVER_TO_CHANNEL_PARTNER, 
                payload: data 
            });
            return data;
        }
        return res?.data;
    } catch (error) {
        return error;
    }
};

export const getContractsByChannelPartner = (channelPartnerId, page = 1, limit = 10) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.channelPartner.fetchContractsByChannelPartner}?channel_partner_id=${channelPartnerId}&page=${page}&limit=${limit}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_CONTRACTS_BY_CHANNEL_PARTNER,
      payload: data,
    });
    return data;
  } else {
    return res;
  }
};

export const invoiceVisibilityByChannelPartner = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            Config.channelPartner.invoiceVisibilityForChannelPartner
        );
        if (res?.data?.status == 0) {
            const { data } = res;
            dispatch({ 
                type: INVOICE_VISIBILITY_FOR_CHANNEL_PARTNER, 
                payload: data 
            });
            return data;
        } 
    } catch (error) {
        return error;
    }
};
